import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Top',
    component: () => import('../views/Top.vue'),
  },
  {
    path: '/*',
    redirect: { name: 'Top' },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = 'Donbler(ドンブラー)';
  next();
});

export default router;
